/**
 * NEX-1016: Der Anforderungstyp ist ein projekt-lokaler freier String — das FE
 * uebernimmt jetzt den vom Provider gelieferten Namen 1:1. Ein Vorgang gilt als
 * importierbar, sobald er ueberhaupt einen Typ-Namen fuehrt.
 */
export function isImportableIssueType(issueTypeName: string | null | undefined): boolean {
  return !!issueTypeName?.trim();
}
